import React from 'react';
import './Services.css';

const Services = () => {
    const services = [
        'Fractional leadership support',
        'Operational support',
        'Aircraft sales and acquisition',
        'Parts sales/procurement',
        'Engine sales/procurement'
    ];

    return (
        <section id="services" className="services-section">
            <ul className="services-list">
                {services.map((service, index) => (
                    <li key={index} className="service-item">
                        <div className="service-name">{service}</div>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default Services; 